export enum GameDataRequests
{
    GET_CORE_MODULE_STATE = "GameDataRequests.GET_CORE_MODULE_STATE",
    GET_GAME_MODE_STATE = "GameDataRequests.GET_GAME_MODE_STATE",
    GET_COINS_STATE = "GameDataRequests.GET_COINS_STATE",
    GET_TOTAL_WIN = "GameDataRequests.GET_TOTAL_WIN",
    GET_TOTAL_BET = "GameDataRequests.GET_TOTAL_BET",
    GET_BALANCE = "GameDataRequests.GET_BALANCE"
}

export enum InstructionIntent
{
    SET_BALANCE = "InstructionIntent.SET_BALANCE",
    DISABLE_AUTOSPIN = "InstructionIntent.DISABLE_AUTOSPIN",
    PAUSE_GAME = "InstructionIntent.PAUSE_GAME",
    RESUME_GAME = "InstructionIntent.RESUME_GAME",
    ENABLE_BALANCE_CHECK = "InstructionIntent.ENABLE_BALANCE_CHECK",
    DISABLE_BALANCE_CHECK = "InstructionIntent.DISABLE_BALANCE_CHECK",
    START_SPIN = "InstructionIntent.START_SPIN",
    DISABLE_AUDIO = "InstructionIntent.DISABLE_AUDIO",
    ENABLE_AUDIO = "InstructionIntent.ENABLE_AUDIO",
    SHOW_PAY_TABLE = "InstructionIntent.SHOW_PAY_TABLE",
    HIDE_PAY_TABLE = "InstructionIntent.HIDE_PAY_TABLE"
}

export enum WrapperEvents
{
    ONPAYTABLE = "ONPAYTABLE",
    SOUND_ENABLED_BY_CLICK = "SOUND_ENABLED_BY_CLICK",
    SOUND = "SOUND",
    SHOW_PAYTABLE = "SHOW_PAYTABLE",
    HIDE_PAYTABLE = "HIDE_PAYTABLE",
    GO_LOBBY = "GO_LOBBY",
    CLOSE_WINDOW = "CLOSE_WINDOW",
    MINI_GAME_ACTIVATED = "MINI_GAME_ACTIVATED",
    MINI_GAME_STARTED = "MINI_GAME_STARTED",
    MINI_GAME_ENDED = "MINI_GAME_ENDED"
}